import { formatNumber } from 'app/helpers'

export const getFeaturesColumns = (features, featuresLabels, labels) => {

    if (!features) return

    let featuresColumns = Object.keys(features).map((featureName) => ({
        key: featureName,
        field: 'features.' + featureName,
        type: features[featureName].dataType === 'STRING' ? 'string' : 'number',
        align: 'left',
        headerAlign: 'left',
        headerClassName:
            features[featureName].dataType !== 'STRING' && 'row-reverse',
        headerName: featuresLabels[featureName] || featureName,
        width: 180,
        valueGetter: (params) => {
            const { dataType } = features[featureName]
            const value = params.row.features[featureName]
            const isNumber = dataType === 'INTEGER' || dataType === 'DOUBLE'
            if (isNumber) {
                return formatNumber(value)
            }
            return value
        },
    }))
    if (labels?.length) {
        featuresColumns = featuresColumns.sort(
            (a, b) => labels.indexOf(a.key) - labels.indexOf(b.key)
        )
    }

    return featuresColumns;
}